import React from 'react';
import { motion } from 'framer-motion';
import homeCloset1 from '../assets/home-closet-1.jpg';
import homeCloset2 from '../assets/home-closet-2.jpg';
import homeCloset3 from '../assets/home-closet-3.jpg';
import homeCloset4 from '../assets/home-closet-4.jpg';

const Projects = () => {
  const images = [
    homeCloset1,
    homeCloset2,
    homeCloset3,
    homeCloset4
  ];

  return (
    <section id="projects" className="py-12 md:py-16 bg-white">
      <div className="container-custom">
        <div className="mb-10 md:mb-12 text-center max-w-4xl mx-auto">
          <h2 className="text-3xl md:text-5xl font-bold text-primary mb-4">Fully Custom Cabinetry Solutions</h2>
          <div className="w-24 h-px bg-accent mx-auto mb-6"></div>
          <p className="text-gray-700 text-lg md:text-xl font-light leading-relaxed">
            Thoughtfully designed cabinetry systems tailored to your space — from closets and garages to architectural built-ins and specialized installations.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
          {/* Large Dominant Feature Image */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="md:col-span-3 aspect-[16/9] overflow-hidden cursor-pointer"
          >
            <img
              src={images[0]}
              alt="Custom Walk-In Closet Feature"
              className="w-full h-full object-cover transition-transform duration-[1500ms] hover:scale-[1.03]"
            />
          </motion.div>

          {/* Remaining 3 Images */}
          {images.slice(1).map((img, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="aspect-[4/3] overflow-hidden cursor-pointer"
            >
              <img
                src={img}
                alt={`Custom Storage Detail ${index + 1}`}
                className="w-full h-full object-cover transition-transform duration-[1500ms] hover:scale-[1.03]"
              />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
